module.exports = __webpack_public_path__ + "media/images/xpass/xpass-bg2-6111293315c975044d66694276a01166.svg";